











































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import {
  GET_SELECTED_USER_TYPE,
  CREATE_USER_TYPE,
  GET_REGISTER_FORM_VISIBILITY,
  UPDATE_REGISTER_FORM_VISIBILITY,
  UPDATE_USER_TYPE_LIST,
  SET_SELECTED_USER_TYPE,
  UPDATE_USER_TYPE,
  FETCH_USER_TYPE_LIST,
  CREATE_USER_TYPE_LIST,
} from '@/modules/user-type/store';
import { IUserType } from '@/modules/user-type/models';
import { MessageService } from '@/services/messageService';

@Component({
  components: {},
})
export default class extends Vue {
  public saving: boolean = false;
  public valid: boolean = false;
  public nome: string = '';
  public state: any = {};
  public newUserType: IUserType = {
    id: 0,
    usertypename: '',
    isactive: true,
  };

  public nameRules: any[] = [
    (v: any) => !!v || 'Nome é obrigatório',
    (v: any) =>
      (v && v.length <= 128) || 'Nome precisa ter menos que 128 caracteres',
  ];

  @Getter(GET_SELECTED_USER_TYPE) // Recupera o tipo de usuário selecionado
  public userTypeSelected: IUserType;

  @Getter(GET_REGISTER_FORM_VISIBILITY) // Recupera flag de exibição do formulário.
  public showUserTypeForm: boolean;

  @Action(CREATE_USER_TYPE) // Cria o tipo de usuário no banco.
  public createUserType: any;

  @Action(UPDATE_USER_TYPE_LIST) // Atualiza a lista de tipos de usuário.
  public updateUserTypes: any;

  @Action(UPDATE_REGISTER_FORM_VISIBILITY) // Seta a flag de exibição do formulário
  private setShowUserTypeForm: any;

  @Action(SET_SELECTED_USER_TYPE) // Seta o tipo usuário atual selecionado.
  private setSelectedUser: any;

  @Action(UPDATE_USER_TYPE) // Atualiza o tipo de usuário no banco.
  private updateUserType: any;

  @Action(FETCH_USER_TYPE_LIST)
  private getAllUserTypes: any;

  @Action(CREATE_USER_TYPE_LIST)
  private setAllUserTypes: any;

  public cancelEdit() {
    this.setSelectedUser(this.newUserType);

    this.getAllUserTypes().then((ret: any) => {
      this.setAllUserTypes(ret[0].data);
      this.setShowUserTypeForm(!this.showUserTypeForm);
    });
  }

  public saveUserType() {
    if (this.userTypeSelected.id === 0) {
      this.addUserType();
    } else {
      this.update();
    }
  }

  private addUserType() {
    this.saving = true;
    this.createUserType(this.userTypeSelected)
      .then((ret: any) => {
        MessageService.Success('Sucesso', 'Operação realizada com sucesso.');
        this.cancelEdit();
      })
      .finally(() => (this.saving = false));
  }

  private update() {
    this.saving = true;
    this.updateUserType(this.userTypeSelected)
      .then(() => {
        this.resetParameters();
      })
      .finally(() => (this.saving = false));
  }

  private resetParameters() {
    MessageService.Success('Sucesso', 'Operação realizada com sucesso.');

    this.setSelectedUser(this.newUserType);
    this.setShowUserTypeForm(!this.showUserTypeForm);
  }
}
